import { gql } from '@apollo/client';

// operations list
export const searchOperations = gql`
  query searchOperations(
    $status: [EntityStatus!]
    $fromTimestamp: String
    $limit: Int
    $text: String
    $cursor: String
    $family: [OperationType!]
    $toTimestamp: String
    $currentStep: [String!]
    $orderBy: String
  ) {
    operations: searchOperations(
      after: $cursor
      parameters: {
        status: $status
        fromTimestamp: $fromTimestamp
        limit: $limit
        text: $text
        include: $family
        toTimestamp: $toTimestamp
        currentStep: $currentStep
        orderBy: $orderBy
      }
    ) {
      edges {
        node {
          deleted
          operationId
          family: type
          customerId
          creationTime
          lastUpdateTime
          currentStep
          steps
          stepsFlow
          status
          results {
            type
            status
            reason
          }
          assets {
            type
            url
            contentType
          }
          stepChanges {
            type
            stepId
            stepType
            component {
              id
              version
            }
            widget {
              id
              version
            }
          }
          stepResults {
            type
            stepId
            stepType
            status
            reason
          }
          stepsFlowData {
            type
            id
            steps
            url
            reducedId
            reducedSteps
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const getOperation = gql`
  query getOperation($tenantId: [String!], $id: String!) {
    operation: getOperationDetails(operationId: $id, tenantId: $tenantId) {
      family: type
      currentStep
      operationId
      lastUpdateTime
      creationTime
      steps
      status
      results {
        type
        status
        reason
      }
      details {
        ... on AuthenticationDetails {
          assets {
            url
            contentType
            type
            source
            characteristics {
              type
              age
              origin
              gender
              quality
              glasses
              lips
              emotion
              source
            }
          }
          device {
            type
            model
            osVersion
            brand
            deviceId
            browser
            deviceType
            engine
            osName
            isRooted
            isEmulated
            hasSIMCard
          }
          coordinates {
            latitude
            longitude
          }
          facialAuthenticateResult {
            similarity
            authStatus
            source
          }
          fingerprintAuthenticateResultList {
            index
            similarity
            authStatus
            source
            component {
              id
              version
            }
            assetsUrl
          }
          facialLivenessResult {
            diagnostic
            description
          }
          ocrData {
            personalInformation {
              name
              surname
              nationality
              documentNumber
              birthDate
              birthPlace
              address
              city
            }
            source
            default
            documentDataFields {
              key
              value
            }
            documentImages {
              type
              url
              contentType
            }
          }
          securityInfoDataList {
            mode
            data
            succeed
            source
            type
          }
        }
        ... on OnboardingDetails {
          coordinates {
            latitude
            longitude
          }
          facialAuthenticateResult {
            similarity
            authStatus
            source
          }
          fingerprintAuthenticateResultList {
            index
            similarity
            authStatus
            source
            component {
              id
              version
            }
            assetsUrl
          }
          facialLivenessResult {
            diagnostic
            description
          }
          device {
            type
            model
            osVersion
            brand
            deviceId
            browser
            deviceType
            engine
            osName
            isRooted
            isEmulated
            hasSIMCard
          }
          ocrData {
            personalInformation {
              name
              surname
              nationality
              documentNumber
              birthDate
              birthPlace
              address
              city
            }
            source
            default
            documentDataFields {
              key
              value
            }
            documentImages {
              type
              url
              contentType
            }
          }
          securityData {
            verificationStatus
            scanStatus
            scanSource
            dataPositions
            documentValidation
            hologramValidation
            mrzCodeVerification
            featuresVerification
            signatureVerification
            documentType
            documentSubType
            country
            rejectReason
            microprintVerification
          }
          securityInfoDataList {
            mode
            data
            succeed
            source
            type
          }
          assets {
            url
            contentType
            type
            characteristics {
              type
              age
              origin
              gender
              quality
              glasses
              lips
              emotion
              source
            }
          }
        }
      }
    }
  }
`;

export const getOperationDetails = gql`
  query GetOperationDetails($operationId: String!, $tenantId: [String!]) {
    operationDetails: getOperationDetails(
      operationId: $operationId
      tenantId: $tenantId
    ) {
      operationId
      type
      details {
        ... on AuthenticationDetails {
          statusChangeList {
            status
            comment
            previousStatus
            timestamp
          }
          extServiceManualChecklist {
            isChecked
            name
          }
        }
        ... on OnboardingDetails {
          operationResults {
            status
            reason
          }
          statusChangeList {
            status
            comment
            previousStatus
            timestamp
          }
          type
          extServiceManualChecklist {
            name
            isChecked
          }
        }
      }
    }
  }
`;
